<template>
  <autocomplete
    v-model="selectedCompanyProxy"
    :items="mealCompanies"
    dense
    filled
    :label="$t('select_company')"
    item-text="name"
    item-value="id"
    return-object
    clear
    chips
    small-chips
    :loading="loading.fetchRestaurantMultiCompanies"
    :disabled="loading.fetchRestaurantMultiCompanies"
  />
</template>

<script>
export default {
  name: "ReportFieldSelectFoodCompany",
  data() {
    return {
      loading: {
        fetchRestaurantMultiCompanies: false,
      },
    };
  },
  computed: {
    selectedCompany: {
      get() {
        return this.$store.state.report.selectedMealCompany;
      },
      set(val) {
        this.$store.commit("report/SET_SELECTED_MEAL_COMPANY", val);
      },
    },
    selectedCompanyProxy: {
      get() {
        return this.selectedCompany;
      },
      set(val) {
        this.selectedCompany = val;
      },
    },
    filters() {
      return this.$store.state.report.filters;
    },
    mealCompanies() {
      return this.$store.getters["report/restaurantMultiCompanies"].map(
        (company) => ({
          ...company,
          name: this.toLatin(company.name || company.company || ""),
        })
      );
    },
    restaurantId() {
      return this.$store.state.restaurant.id;
    },
  },
  watch: {
    restaurantId: {
      async handler(newVal) {
        if (this.loading.fetchRestaurantMultiCompanies) {
          console.warn(
            "Fetch meal companies operation already in progress, skipping duplicate request"
          );
          return;
        }

        if (!newVal) return;

        this.loading.fetchRestaurantMultiCompanies = true;

        try {
          await this.$store.dispatch("report/fetchRestaurantMultiCompanies");

          if (this.mealCompanies && this.mealCompanies.length && !this.selectedCompany) {
            this.selectedCompany = this.mealCompanies[0];
          }
        } catch (error) {
          console.error("Error fetching meal companies:", error);
        } finally {
          this.loading.fetchRestaurantMultiCompanies = false;
        }
      },
      immediate: true,
    },
    mealCompanies: {
      handler(companies) {
        if (companies && companies.length && !this.selectedCompany) {
          this.selectedCompany = companies[0];
        }
      },
      immediate: true,
    },
  },
};
</script>
